import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Shield, TrendingUp, Trophy, Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = `${process.env.REACT_APP_BACKEND_URL}/api/static/kpl-logo-color.png`;
const LOGO_WHITE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/static/kpl-logo-white.png`;

export default function TeamPage() {
  const { teamId } = useParams();
  const [team, setTeam] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    axios.get(`${API}/teams/${teamId}`).then((r) => setTeam(r.data.team)).catch(() => setFailed(true));
  }, [teamId]);

  if (failed) return <div className="site-shell"><div className="container" style={{ padding: "120px 24px" }}><p>Team not found. <Link to="/">Back to site</Link></p></div></div>;
  if (!team) return <div className="site-shell"><div className="container" style={{ padding: "120px 24px" }} data-testid="team-loading">Loading team…</div></div>;

  const sold = (team.squad || []).filter((p) => p.price);
  return <div className="site-shell team-page" data-testid="team-page">
    <div className="team-hero" style={{ background: `linear-gradient(120deg, ${team.colour || "#024ea7"} 0%, #071c33 75%)` }}>
      {team.banner_url && <img className="team-hero-banner" src={`${API.replace("/api", "")}${team.banner_url}`} alt="" />}
      <div className="container team-hero-inner">
        <Link to="/" className="auth-home" data-testid="team-back"><ArrowLeft size={15} /> BACK TO SITE</Link>
        <div className="team-hero-row">
          {team.logo_url ? <img className="team-hero-logo" src={`${API.replace("/api", "")}${team.logo_url}`} alt={`${team.name} logo`} data-testid="team-hero-logo" />
            : <b className="team-badge team-hero-badge" style={{ background: team.colour || "#024ea7" }} data-testid="team-hero-badge">{team.short}</b>}
          <div>
            <p className="team-hero-short">{team.short} · KPL SEASON ONE</p>
            <h1>{team.name}</h1>
            <p className="team-hero-meta">
              {team.owner && <span><Shield size={13} /> Owner: {team.owner}</span>}
              {team.coach && <span><Users size={13} /> Coach: {team.coach}</span>}
              {team.staff && <span>{team.staff}</span>}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div className="container team-body">
      {sold.length > 0 && <div className="admin-card purse-strip" data-testid="purse-strip">
        <div><label>SQUAD</label><b>{team.squad.length} players</b></div>
        <div><label>SPENT</label><b>₹{sold.reduce((sum, p) => sum + (parseFloat(String(p.price).replace(/[^\d.]/g, "")) || 0), 0).toFixed(1)} L</b></div>
        <div><label>BOUGHT AT AUCTION</label><b>{sold.length}</b></div>
      </div>}

      <h2 className="team-squad-title">Squad {team.squad.length > 0 && <span>({team.squad.length})</span>}</h2>
      {team.squad.length === 0 ? <p className="reg-empty" data-testid="squad-empty">Squad will be announced after the player auction — follow KPL on Instagram for updates.</p> : (
        <div className="squad-grid">
          {team.squad.map((p) => <div className="player-card" key={p.id} data-testid={`player-card-${p.name.replace(/\s+/g, "-").toLowerCase()}`}>
            {p.photo_url ? <img className="player-card-photo" src={`${API.replace("/api", "")}${p.photo_url}`} alt={p.name} />
              : <div className="player-card-photo player-card-empty" style={{ background: team.colour || "#024ea7" }}>{p.name.slice(0, 1)}</div>}
            {p.jersey && <span className="player-jersey">#{p.jersey}</span>}
            <b>{p.name}</b>
            <span className="player-role">{p.role || "Player"}{p.category ? ` · Grade ${p.category}` : ""}</span>
            {p.price && <span className="player-price"><Trophy size={11} /> ₹{p.price}</span>}
            {p.stats && <span className="player-stats"><TrendingUp size={11} /> {p.stats.batting?.runs || 0} runs · {p.stats.bowling?.wickets || 0} wkts</span>}
          </div>)}
        </div>
      )}
    </div>
  </div>;
}
